import { BUTTON_SUBMISSION, MY_ACCOUNT_SETTINGS, OVERLAY } from '../constants';

const trackEvent = (settings) => {
  const DDOEvent = {
    category: {
      primaryCategory: BUTTON_SUBMISSION
    },
    eventInfo: {
      eventName: MY_ACCOUNT_SETTINGS
    },
    myAccount: {
      settings
    }
  };

  digitalData.event = digitalData.event || [];
  digitalData.event.push(DDOEvent);
};

// convert-to-pro-analytics.ts button submission events
export const convertToProEvents = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('convert-to-pro.cancel-event', ({ output }) => {
    const settings = output?.settings || '';
    trackEvent(settings);
  });

  // setVerificationCodeSendAndResendAnalytics(isResend, method)
  window.LIFE_CYCLE_EVENT_BUS.on('convert-to-pro.verification-code', ({ output }) => {
    const isResend = output?.isResend || false;
    const method = output?.method || '';
    const action = isResend ? 'resend code' : 'verification code';

    trackEvent(`convert to pro: verify your identity: ${action}: ${method}`);
  });

  // setOverlayEvent(eventName) (src/utils/analytics.ts) - modal-mount views
  // Shared by info-modal-content.tsx ('convert to a pro xtra account'),
  // verify-method-modal-content.tsx ('convert to pro verify your identity'),
  // and company-details-modal-content.tsx ('create pro xtra loyalty account').
  window.LIFE_CYCLE_EVENT_BUS.on('convert-to-pro.overlay-view', ({ output }) => {
    const step = output?.step || '';

    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: step
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  // setOverlayEvent('pro xtra account created', { user: { customerType: 'pro' } }) (convert-to-pro/index.tsx)
  window.LIFE_CYCLE_EVENT_BUS.on('convert-to-pro.account-created', () => {
    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'pro xtra account created'
      },
      user: {
        customerType: 'pro'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
